import React from 'react';
import './Footer.css';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  
  const navigationItems = [
    { key: 'problem', label: t('header.problem') },
    { key: 'cozum', label: t('header.solution') },
    { key: 'design', label: t('header.design') },
    { key: 'technology', label: t('header.technology') }
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-left">
            <div className="footer-logo">
              <img src="/images/Group 1000003026.png" alt="PhiAI Logo" className="footer-logo-image" />
            </div>
            <div className="footer-address">
              <h4 className="address-title">PhiAI Teknoloji</h4>
              <p className="address-line">Atatürk Mh. İlbey Sk. No:3 Plaza42 Ataşehir/İSTANBUL</p>
              <p className="address-line">Email: info@phitech.ai</p>
              <p className="address-line">Phone: +90 (216) 693 03 05-06</p>
            </div>
            <p className="copyright">Copyright 2025 PhiAI</p>
          </div>
          
          <div className="footer-right">
            <div className="footer-navigation">
              {navigationItems.map((item, index) => (
                <button 
                  key={index}
                  className="footer-nav-button"
                  onClick={() => scrollToSection(item.key)}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 